import { Card, Row, Spin } from "antd";
import { useMemo, useState } from "react";
import { Header } from "./components/Header";
import { useFetchData } from "../PayoffAmounts/hooks/useFetchData";
import { KPI_CODES } from "../../kpiCodes";
import AreaChart from "../AreaChart";

type ChatConversationsProps = {
  conversations: any;
  isDataLoading: boolean;
  isRecalculated: boolean;
};

export const ChatConversations = ({
  conversations,
  isDataLoading,
  isRecalculated,
}: ChatConversationsProps) => {
  const [granularity, setGranularity] = useState<number>(1);

  const codes: string[] = useMemo(
    () => [
      KPI_CODES.CHAT_TODAY,
      KPI_CODES.CHAT_THIS_MONTH,
      KPI_CODES.CHAT_THIS_YEAR,
    ],
    [],
  );

  const { isLoading, data } = useFetchData(
    granularity,
    isRecalculated,
    codes,
    "Chat Conversations",
  );

  return (
    <Card className="dashboard-card top">
      <Header granularity={granularity} setGranularity={setGranularity} />
      <Row className="d-block h-100">
        {!isDataLoading ? (
          <Row className="d-block">
            <Row className="mb-6 mt-2">
              <h3 className="h h3">{conversations[granularity]}</h3>
            </Row>
            <AreaChart isLoading={isLoading} data={data} />
          </Row>
        ) : (
          <Row className="h-100 justify-center align-center">
            <Spin size="large" />
          </Row>
        )}
      </Row>
    </Card>
  );
};
